/** Crawler-only HTML injected outside #root (see client/scripts/generate-seo.js). */
const SEO_FALLBACK_SELECTOR = '[data-seo-fallback="true"]';

/**
 * Prefer attribute lookup over getElementById — JSON-LD scripts historically
 * reused the same id as the visible <main>, so getElementById hit the script.
 */
export function getSeoFallback(id?: string): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  if (id) {
    const byId = document.getElementById(id);
    if (byId?.matches?.(SEO_FALLBACK_SELECTOR)) return byId;
    const matches = document.querySelectorAll<HTMLElement>(SEO_FALLBACK_SELECTOR);
    for (let i = 0; i < matches.length; i += 1) {
      if (matches[i].id === id) return matches[i];
    }
  }
  return document.querySelector<HTMLElement>(SEO_FALLBACK_SELECTOR);
}

export function hasSeoFallback(id?: string): boolean {
  return Boolean(getSeoFallback(id));
}

/** Remove crawler fallback nodes from the document. */
export function removeSeoFallbacks(): void {
  if (typeof document === 'undefined') return;
  document.querySelectorAll(SEO_FALLBACK_SELECTOR).forEach((el) => el.remove());
}
